import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CompanyService } from './company.service';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { CompanyListItem } from '../models/company-list.model';


@Injectable({ providedIn: 'root' })
export class ComapnyListResolver implements Resolve<HttpResponse<CompanyListItem[]>> {
  constructor(
    private companyService: CompanyService
  ) { }

  resolve() {
    const httpParams = new HttpParams()
      .set('orderby', 'Name asc')
      .set('filter', 'IsActive == True')
      .set('page', '1')
      .set('pageSize', '20');
    return this.companyService.get(httpParams);
  }
}
